import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateChild } from "@angular/router";
import { UnavailabilityService } from "@edp-services/unavailability.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class EdpUnavailabilityGuard implements CanActivateChild {

    constructor(private unavailabilityService: UnavailabilityService) { }

    canActivateChild(next: ActivatedRouteSnapshot): boolean | Observable<boolean> {

        if (!next.data.unavailabilityToCheck) {
            this.unavailabilityService.setUnavailability(undefined);
            return true;
        }

        if (!!this.unavailabilityService.checkRequested()) {
            this.unavailabilityService.findUnavailability(next.data.unavailabilityToCheck);
            return true;
        }

        return this.unavailabilityService.getUnavailability().pipe(
            map(() => {
                this.unavailabilityService.findUnavailability(next.data.unavailabilityToCheck);
                return true;
            }));
    }
}
